import React, { useEffect, useState, useRef } from "react";
import locationIcon from '../assets/location.svg'
import arrowDown from '../assets/arrowDown.svg'
import { AiOutlineSearch } from "react-icons/ai";

const CountrySelector = ({ page, searchError, setSearchError, vendorCountryData, handleCountrySelect, device, placeholder }) => {
  const [inputValue, setInputValue] = useState("");
  const [selected, setSelected] = useState("");
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null); // Create a ref for the dropdown

  const handleOpen = () => {
    setSearchError('')
    setOpen(!open)
  }
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  return (
    <div className={`relative w-full cursor-pointer ${device != "small" && searchError === "Category or Country is Required" ? "rounded-l-[80px] border border-[#EB0728]" : ""}`} ref={dropdownRef}>
      <div
        onClick={() => handleOpen()}
        className={` w-full py-[14px] px-[19px] font-medium  text-base  lg:text-sm ${device === "small" ? ` ${searchError === "Category or Country is Required" || searchError === "Invalid Search" ? "text-[#EB0728] bg-white  border-2 border-[#EB0728] " : page === 'dashboard' ? "bg-white" : "bg-white"} rounded-[80px] border  ${page === 'dashboard' ? "bg-white" : ""}` : "rounded-l-[80px] w-[200px] "} h-[45px] xl:h-[50px] flex  items-center justify-between text-center ${!selected && "text-[#707070]"}`}>
        {selected
          ? selected.length > 15
            ? selected.substring(0, 15) + "..."
            : selected
          :           <div className={`flex gap-[8px] font-medium text-base lg:text-sm ${searchError?'text-[#EB0728]':''} `}>

            {/* <img src={locationIcon} alt="" className="size-[20px]" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 -960 960 960"
              width="20px"
              className={`size-[20px] ${searchError ? "text-[#EB0728]" : "text-[#707070]"}`}
              fill="currentColor"
            >
              <path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
            </svg>

            {placeholder ? placeholder : <h1>Country</h1>}
          </div>}
        {device === "small" ?
          // <img src={arrowDown} alt='arrowdown' className={`${open && "rotate-180"}`} />
          <svg
            width="13"
            height="9"
            viewBox="0 0 13 9"
            xmlns="http://www.w3.org/2000/svg"
            className={`${searchError ? "text-[#EB0728]" : "text-[#707070]"} ${open && "rotate-180"}`}
            fill="currentColor"
          >
            <path d="M6.5 8.04167L0.25 1.79167L1.36979 0.671875L6.5 5.80208L11.6302 0.671875L12.75 1.79167L6.5 8.04167Z" />
          </svg>

          : null}
      </div>
      <ul
        className={`shadow-input w-full bg-white mt-2 overflow-y-auto flex flex-col absolute rounded-md z-[80] text-start ${open ? "h-[30vh]" : "max-h-0"}`}
      >
        <div className="flex items-center px-[14px] text-base lg:text-sm sticky top-0 bg-white">
          <AiOutlineSearch size={18} className="text-ravinput" />
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value.toLowerCase())}
            placeholder={placeholder ? placeholder : "Enter country name"}
            className="placeholder:text-ravinput  py-2 font-medium px-[14px] outline-none "
          />
        </div>
        {vendorCountryData
          ?.sort((a, b) => a?.vendor_country_name?.localeCompare(b?.vendor_country_name))
          ?.map((country, index) => (
            <li
              key={index}
              className={`py-2  px-[14px]  hover:bg-sky-600 hover:text-white text-base lg:text-sm
                ${country?.vendor_country_name?.toLowerCase() === selected?.toLowerCase() && "bg-sky-600 text-white"}
                ${country?.vendor_country_name?.toLowerCase().startsWith(inputValue) ? "block" : "hidden"}`}
              onClick={() => {
                if (country?.vendor_country_name?.toLowerCase() !== selected.toLowerCase()) {
                  setSelected(country?.vendor_country_name);
                  setOpen(false);
                  setInputValue("");
                  handleCountrySelect(country?.vendor_country_name)
                }
              }}
            >
              {country?.vendor_country_name}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default CountrySelector;
